export const API_URL = "/usersApi/";
export const API_OK = "OK";
export const API_EXCEPTION = "Exception";
export const DEFAULT_ERROR_TITLE = "Error";
export const DEFAULT_ERROR_TEXT = "Error ocurred during operation";
export const ERROR_SESSION_EXPIRED = "session_expired";
export const ERROR_BAD_SESSION = "bad_session";
export const ERROR_BAD_REQUEST = "bad_request";
export const INCORRECT_LOGIN = "incorrect_login";
export const ERROR_USER_ALREADY_EXISTS = "user_already_exists";
export const THEME_SIM_CUSTOMERS = "sim_customers";
export const IVR_HOSTS = ["ivr.yemot.co.il", "localhost:4200"];
